import React, { useMemo } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { useMgaPeriods } from '../../mga/useData';
import { StatCounterGrid, type StatCounterItem } from './shared';

const MgaPeriodCounters: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { colors } = useTheme();
  const { data, isLoading } = useMgaPeriods(undefined, 1, 200);

  const counters: StatCounterItem[] = useMemo(() => {
    let draft = 0;
    let open = 0;
    let closed = 0;
    let pendingClose = 0;
    for (const period of data ?? []) {
      if (period.status === 'DRAFT') draft += 1;
      else if (period.status === 'OPEN') open += 1;
      else if (period.status === 'CLOSED') closed += 1;
      if (period.closeApprovalStatus === 'PENDING') pendingClose += 1;
    }
    return [
      {
        key: 'draft',
        label: 'Draft',
        value: draft,
        href: '/mga',
        accent: colors.primary,
      },
      {
        key: 'open',
        label: 'Open',
        value: open,
        href: '/mga',
        accent: 'bg-emerald-500',
      },
      {
        key: 'closed',
        label: 'Closed',
        value: closed,
        href: '/mga',
        accent: colors.accent,
      },
      {
        key: 'pending-close',
        label: 'Pending close',
        value: pendingClose,
        href: '/mga',
        accent: 'bg-amber-500',
      },
    ];
  }, [colors.accent, colors.primary, data]);

  return (
    <StatCounterGrid
      title="MGA · Periods"
      counters={counters}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/mga"
    />
  );
};

export default MgaPeriodCounters;
